import base64url from 'base64url';

export const uuidToBase64Url = (uuid: string): string => base64url(
  Buffer.from(uuid.replaceAll('-', ''), 'hex'),
);
